// extracted by mini-css-extract-plugin
export default {"usersPage":"ayMYES17","header":"nvGiTZp5","actions":"p37YHaP6"};